const CentralHub = ({ content, onDeselect }) => {
  return (
    <div
      className="relative rounded-full bg-gradient-to-br from-sky-500 to-cyan-400 shadow-2xl flex items-center justify-center text-white text-center font-extrabold w-56 h-56 sm:w-64 sm:h-64 z-20 animate-breathing-glow cursor-pointer shadow-inner-lg"
      onClick={onDeselect}
      role="button"
      aria-label="Deselect feature"
    >
      <div className="absolute inset-0 rounded-full border-2 border-sky-300/50 animate-radar-pulse"></div>
      <div className="absolute inset-0 rounded-full border-2 border-sky-300/50 animate-radar-pulse [animation-delay:1.5s]"></div>

      <div className="relative transition-all duration-500 ease-out-expo">
        {content.icon && (
          <div className="text-5xl sm:text-6xl mb-2 flex justify-center">
            {content.icon}
          </div>
        )}
        <div className="text-2xl sm:text-3xl text-shadow-lg">
          {content.title}
        </div>
      </div>
    </div>
  );
};

export default CentralHub;
